import React from 'react'
import PropTypes from 'prop-types'
import R from 'ramda'

import {
  post
} from '_utils/xhr'

import SerialForm from '_forms/serialForm'
import CreateModalWrapper from '_forms/createModal'

const serial = {
  name: '',
  email: '',
  max_version: 6,
  serial_number: ''
}

class AddSerialModal extends React.PureComponent {
  state = {
    open: false,
    serial: R.merge({}, serial),
    dirty: false,
    msg: {
      fetching: false,
      visible: false,
      errorMessage: null
    }
  }

  onDismiss = () => {
    this.setState({msg: R.merge(this.state.msg, {visible: false})})
  }

  onSubmit = (e, data) => {
    e.preventDefault()
    const urlPath = '/serials'
    post(
      urlPath,
      this.state.serial
    )
      .then(body => {
        if (this.props.onCreate) {
          this.props.onCreate(body)
          this.setState({
            dirty: false,
            open: false,
            msg: {errorMessage: null, visible: false, fetching: false},
            serial: R.merge({}, serial)
          })
        }
      })
      .catch(err => this.setState({msg: {errorMessage: err.message, visible: true, fetching: false}}))
  }

  onChange = (e, data) => this.setState({
    serial: R.merge(this.state.serial, {[data.name]: data.value}),
    dirty: true
  })

  onCancel = (e) => {
    e.preventDefault()
    this.setState({
      serial: serial,
      dirty: false
    })
  }
  onOpen = () => this.setState({open: true})
  onClose = () => this.setState({open: false})

  render () {
    return (
      <CreateModalWrapper
        onOpen={this.onOpen}
        onClose={this.onClose}
        open={this.state.open}

        onDismiss={this.onDismiss}
        {...this.state.msg}
        header='Create a new serial'
        type='serial'
        iconName='plus'
        iconHeader='Add Serial'
      >
        <SerialForm
          serial={this.state.serial}
          dirty={this.state.dirty}
          onSubmit={this.onSubmit}
          onChange={this.onChange}
          onCancel={this.onCancel}
        />
      </CreateModalWrapper>
    )
  }
}

AddSerialModal.propTypes = {
  onCreate: PropTypes.func.isRequired
}

export default AddSerialModal



// WEBPACK FOOTER //
// ./webAdmin/components/serials/addSerial.js